import { SEGMENT_POOL } from '../sharedConfig';
import orangellow from './orangellow';
import general1k from './general1k';
import general5k from './general5k';
import general10k from './general10k';
import greenEnergy from './greenEnergy';
import construction from './construction';
import constructionStaffing from './constructionStaffing';
import hospice from './hospice';
import hempCbd from './hempCbd';
import kratom from './kratom';

export const ALL_BLUEPRINTS = [orangellow, general1k, general5k, general10k, greenEnergy, construction, constructionStaffing, hospice, hempCbd, kratom];

const CHANNEL_PARTNER_MATCH = [
  { match: ['orangellow'], blueprint: orangellow },
];

const BUDGET_TIERS = [
  { min: 1000, max: 4999, blueprint: general1k },
  { min: 5000, max: 9999, blueprint: general5k },
  { min: 10000, max: Infinity, blueprint: general10k },
];

// Returns the recommended blueprint based on partner/budget (can be null)
export function getRecommendedBlueprint(channelPartnerName, cpAcronym, budget) {
  const partner = String(channelPartnerName || '').toLowerCase();
  const acronym = String(cpAcronym || '').toLowerCase();

  for (const { match, blueprint } of CHANNEL_PARTNER_MATCH) {
    if (match.some((m) => partner.includes(m) || acronym.includes(m))) {
      return blueprint;
    }
  }

  const budgetNum = Number(budget) || 0;
  for (const { min, max, blueprint } of BUDGET_TIERS) {
    if (budgetNum >= min && budgetNum <= max) {
      return blueprint;
    }
  }

  return null;
}

export function resolveSegment(segmentKey) {
  if (!segmentKey) return null;
  return SEGMENT_POOL[segmentKey] || null;
}

export function getStrategySetOptions(blueprint) {
  if (!blueprint) return [];
  return Object.entries(blueprint.strategySets).map(([key, set]) => ({
    key,
    label: set.label,
    lineItems: set.lineItems,
  }));
}
